import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { UtilisationSummary } from '@/types/utilisation';

export function useUtilisationSummary() {
  return useQuery<UtilisationSummary>({
    queryKey: ['utilisation', 'summary'],
    queryFn: async () => {
      const { data } = await api.get<UtilisationSummary>('/utilisation/summary');
      return data;
    },
    staleTime: 60_000,
  });
}
